module.exports = __webpack_public_path__ + "static/media/fa-brands-400.e8019d50.eot";